import React, { useEffect, useMemo, useState } from "react";
import { RCCButton, RCCGrid, RCCHookToast, RCCInput, RCCServicesApi, RCCTextArea,  RCCTooltip } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { v4 } from "uuid";
import { IEftba018 } from "../../IntegrationTypes/interface";
import { ITabDataOriginSettings } from "../interface";

const TabSettings : React.FC<ITabDataOriginSettings> = ({
	data,
	error, 
	watch,
	setValue,
	register
}) => {
 
	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();

	const [showModel, setShowModel] = useState(false);
	const [showConfig, setShowConfig] = useState(false);
	const [modelData, setModelData] = useState<IEftba018 | null>(null);
	const [showConfirmButton, setShowConfirmButton] = useState(false);

	const { 
		handleSubmit: handleSubmitAdvancedConfig, 
		register : registerAdvancedConfig
	} = useForm();

	const integrationType = watch("efa020Efa018Id");

	useEffect(() => {
		if(integrationType)
			queryModelSettingOrigin(integrationType);
		setShowConfig(false);
		setShowModel(false);
	}, [integrationType]);

	const queryModelSettingOrigin = async (id: string) => {
		try{
			const response = await RCCServicesApi.getRequest({
				method: "IntegrationTypes/Select",
				urlParameters: {
					id
				}
			});
			setModelData(response.data);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar dados"), addToast);
		}
	};

	const SimpleConfig = useMemo(() => (
		<>
			{showModel && (
				<RCCGrid
					container
					item
					xs={12}
				>	
					<RCCTextArea 
						name="modelConfig"
						label={translate("Modelo")}
						defaultValue={modelData ? modelData.efa018Templateconfig: ""}
						required
						disabled			
					/> 
				</RCCGrid>
			)}
			<RCCGrid
				container
				item
				xs={12}
			>	
				<RCCTextArea 
					name="efa020Configuracao"
					label={translate("Configuração")}
					register={register}
					defaultValue={data.efa020Configuracao}
					required
					error={error.efa020Configuracao}			
				/> 
			</RCCGrid>
		</>
	), [modelData, showModel, error]);

	const AdvancedConfig = useMemo(() => (
		<RCCGrid
			container
			item
			xs={12}
		>	
			{modelData?.eftba019.map((item) => (
				<RCCInput
					key={v4()}
					name={item.efa019Nome}
					label={translate(item.efa019Descricao)}
					register={registerAdvancedConfig}
					defaultValue=" "
					onClick={() => setShowConfirmButton(true)}
				/>
			))}
		</RCCGrid>
	), [modelData]);

	const submitAdvancedConfig = (dataX: {[key: string]: string;}) => {
		let templateChanged = modelData?.efa018Templateconfig;
		let hasAllBlack = true;
		if(!templateChanged) 
			return;
		Object.keys(dataX).forEach((item) => {
			if(dataX[item].trim() !== ""){
				templateChanged = templateChanged?.replace(`{{${  item  }}}`, dataX[item]);
				hasAllBlack = false;
			}
		});
		if(!hasAllBlack)
			setValue("efa020Configuracao", templateChanged);
	};

	const onClickAdvancedConfig = async () => {
		setShowConfig((prevState) => !prevState);
	};

	const onClickConfirmChanges = async () => {
		await handleSubmitAdvancedConfig(submitAdvancedConfig)();
		setShowConfirmButton(false);
	};

	return (
		<>

			<RCCGrid 
				item
				container	
				
				direction="column"
				alignItems="center"
			>
				<RCCGrid
					item
					container
					xs={12}
					sm={10}	
					justifyContent="flex-end"
				>

					{!showConfig && (
						<RCCTooltip
							text={ showModel ? translate("Ocultar modelo") : translate("Mostrar modelo")}
							color={showModel ? "purple" : "grey"}
						>	
							<RCCButton
								icon={{name: "eye"}}
								color={showModel ? "purple" : "grey"}
								onClick={() => {
									setShowModel((prevState) => !prevState);
								}}
								size="md"
								layout="isRounded"
							/>
						</RCCTooltip>
					)}
					{modelData && modelData.eftba019.length > 0 && (
						<React.Fragment key={v4()}>
							<RCCTooltip
								text={ showConfig ? translate("Ocultar configuração avançada") : translate("Mostrar configuração avançada")}
								color={showConfig ? "purple" : "grey"}
							>	
								<RCCButton
									icon={{name: "exchange"}}
									color={showConfig ? "purple" : "grey"}
									onClick={onClickAdvancedConfig}
									size="md"
									layout="isRounded"
								/>
							</RCCTooltip>
						</React.Fragment>
					)}	

				</RCCGrid>
			
				<RCCGrid
					item
					container
					justifyContent="center"
					xs={12}
					sm={10}
				>
					{showConfig ? (
						<>
							{AdvancedConfig}	
						</>
					): (
						<>
							{SimpleConfig}		
						</>
					)}			

					<RCCGrid
						item
						container
						justifyContent="flex-end"
					>
						{showConfig && showConfirmButton && (
							<RCCButton
								icon={{name: "check"}}
								color="green"
								onClick={onClickConfirmChanges}
								size="sm"
								layout="default"
							>
								{translate("Confirmar")}
							</RCCButton>
						)}
					</RCCGrid>
				</RCCGrid>
	
			</RCCGrid>

		</>
	);
};



export default TabSettings;
